import GSObject from "../Game/Base/GSObject";
import gameKit from "../GameKit";
import { Cursor } from "./Cursor";

export default class CanvasButton extends GSObject {
    constructor(parent) {
        super(parent);

        this._respondsToUI = true;
        this.zIndex = 0;
        this.state = 0;
    }

    checkUICollision(position) {
        return false;
    }

    onHoverEnter() { 
        gameKit.setCursor(Cursor.pointer);
    }

    onHoverMove(mousePositionP) { }

    onHoverExit() { 
        gameKit.setCursor(Cursor.def);
    }

    onMouseDown() { }

    onMouseMove(mousePositionP) { 
        if (this.checkUICollision(mousePositionP)) {
            gameKit.setCursor(Cursor.pointer);
            this.validClick = true;
        }
        else {
            gameKit.setCursor(Cursor.def);
            this.validClick = false;
        }
    }

    onMouseUp() { }
}